<div class="ui icon message hidden">
  <i class="icon"><svg    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 54"><path d="M15 45h16v-8s3.14-4.62 5-8c3.34-6.05-.58-20.13-13.19-20C10.57 9.13 7 21.88 10.39 28.84 13.39 34.46 15 37 15 37z" fill="none" stroke="#9d6d00" stroke-width="2"/><path d="M16.09 22.9s3.73-4.48 6.46-1.62S28 22 28.94 21" fill="none" stroke="#9d6d00" stroke-width="2"/><path d="M17 48h12v2H17zm3 4h6v2h-6zm20-29h6v2h-6zM0 23h6v2H0zM24 0v6h-2V0zm12 11l4.85-3.54L42 9l-4.85 3.54zM5.22 7.39L10 11l-1.21 1.59L4 9z" fill="#9d6d00"/></svg></i>

  <div class="content">
    <div class="header">
      <ng-content></ng-content>
    </div>
  </div>

  <i class="close icon" (click)="onClose()"><svg    data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg></i>
</div>
